import { ProjectTypes } from '@platform/types';
import { ResourceType } from 'maplibre-gl';
import { extractFieldsFromRuleGroup } from './utils';

export const nonTileRequests = (url: string, resourceType?: ResourceType): string => {
  if (!resourceType || !['Tile', 'Glyphs'].includes(resourceType)) {
    return url;
  }
  return '';
};

export const mapTilerTilesRequests = (url: string): string => {
  // handling MapTiler tile (and glyphs) requests
  // make sure all MapTiler tile/glyph requests proxy through our platform API, so we can add API keys
  if (url.includes(ProjectTypes.MapTileSource.MAPTILER_SOURCE)) {
    return `${process.env.NX_PE_API}/${url}`;
  }
  return '';
};

export const geoBufferTilesRequests = (url: string, mapSpec: ProjectTypes.MapSpec): string => {
  const layers: string[] = [];
  const columns: string[] = [];
  const { workingLayers } = mapSpec;

  if (url.includes('STYLE-SPEC:')) {
    const regex = new RegExp(`STYLE-SPEC:.*:(.*)$`);
    const match = regex.exec(url);
    const workingLayerId = match ? match[1] : null;

    const workingLayerSpec = workingLayers.find((x) => x.id === workingLayerId);

    if (workingLayerSpec) {
      const { variableSelection, tooltip, filter, metadata } = workingLayerSpec;
      const { geoLayerId, dataLayerId, identifiers } = metadata;

      layers.push(geoLayerId);

      // needed for identifying rows for tooltips etc
      columns.push(`${geoLayerId}.${identifiers.row.datasetId}.${identifiers.row.variableId}`);

      // if (type === 'POLYGON') {
      //   const centroidGeo = `${geoLayerId}p`;
      //   layers.push(centroidGeo);
      //   columns.push(`${centroidGeo}.${identifiers.row.datasetId}.${identifiers.row.variableId}`);
      //
      //   // if (identifiers.name != null) {
      //   //   columns.push(`${centroidGeo}.${identifiers.name.datasetId}.${identifiers.name.variableId}`);
      //   // }
      // }

      if (identifiers.name != null) {
        // needed for identifying names of records
        columns.push(`${geoLayerId}.${identifiers.name.datasetId}.${identifiers.name.variableId}`);
      }

      variableSelection.forEach((x) => {
        columns.push(`${geoLayerId}.${dataLayerId}.${x.variableId}`);
      });

      if (tooltip.enabled) {
        if (tooltip.title) {
          columns.push(`${geoLayerId}.${dataLayerId || 0}.${tooltip.title.variableId}`);
        }
        tooltip.content.forEach((x) => {
          columns.push(`${geoLayerId}.${dataLayerId}.${x.variableId}`);
          if (x.comparisonBase?.base.variableId) {
            columns.push(`${geoLayerId}.${dataLayerId}.${x.comparisonBase?.base.variableId}`);
          }
        });
      }

      if (filter) {
        extractFieldsFromRuleGroup(filter).forEach((c) => {
          columns.push(`${geoLayerId}.${dataLayerId}.${c.trim()}`);
        });
      }
    }
  }

  return url.replace('{layers}', layers.join('.')).replace('{columns}', encodeURIComponent(columns.join(',')));
};
